import React from 'react'
import { Outlet } from 'react-router-dom'

const Article = () => {
    return (
        <><Outlet /></>
    )
}

export default Article